import { DatePipe } from '@angular/common';
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';


export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  providers: [
    DatePipe,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatepickerComponent),
      multi: true
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class DatepickerComponent implements OnInit {

  private calculateNextTenYears(): Date {
    const currentDate = new Date();
    return new Date(currentDate.setFullYear(currentDate.getFullYear() + 10));
  }

  @Input() set control(value: AbstractControl | null) {
    if (value) {
      this.dateControl = value as FormControl;
    }
  }
  @Input() label: string = 'DD/MM/YYYY';
  @Input() maxDate: Date = this.calculateNextTenYears();
  @Input() appearance: any = 'fill';
  @Input() matLabel: any = '';
  

  dateControl: FormControl = new FormControl();
  constructor(private datePipe: DatePipe) { }

  ngOnInit() {
    this.dateControl.valueChanges.subscribe(value => {
      if (value) {
        this.formatDate(new Date(value));
      }
    });
  }

  onDateChange(event: any): void {
    const date = event?.value;
    if (date) {
      this.formatDate(date);
    }
  }

  private formatDate(date: Date): void {
    if (!date) return;

    const today = new Date();
    let formattedDate: string | null;

    if (date < today) {
      formattedDate = this.datePipe?.transform(date, 'MMMM d, y');
    } else {
      formattedDate = this.datePipe?.transform(date, 'MM/dd/yyyy');
    }    
  }
}